import React, { useRef } from "react";
import {motion} from "motion/react"
import {
  flipkartLogo,
  meeshoLogo,
  naykaLogo,
  myntraLogo,
  amazonLogo,
  dataImg,
  dataFillImg,
  rotate1,
  rotate2,
  rotate3,
  rotate4,
  rotate5,
  frame1,
frame2,
frame3,
frame4,
frame5,
} from '../../../../../images/index.js';
import OrbitIcons from "./OrbitIcons.jsx";
import OrbitDesign from "./OrbitLeftMoving.jsx";
import OrbitRightDesign from "./OrbitRightMoving.jsx";
  const icons = [
  rotate1,
  rotate2,
  rotate3,
  rotate4,
  rotate5,
  ];
  const rotateIcon = [
    frame1,
frame2,
frame3,
frame4,
frame5,
  ]

const brands = [
  { name: "Amazon", logo: amazonLogo, width: "120px", height: "60px" },
  { name: "Flipkart", logo: flipkartLogo, width: "135px", height: "auto" },
  { name: "Myntra", logo: myntraLogo, width: "128px", height: "auto" },
  { name: "Nykaa", logo: naykaLogo, width: "110px", height: "36px" },
  { name: "Meesho", logo: meeshoLogo, width: "160px", height: "34px" },
  { name: "Ajio", logo: flipkartLogo, width: "130px", height: "auto" },
  { name: "Snapdeal", logo: amazonLogo, width: "125px", height: "60px" },
  { name: "TataCliq", logo: myntraLogo, width: "120px", height: "auto" },
  { name: "Reliance Trends", logo: naykaLogo, width: "115px", height: "36px" },
  { name: "ShopClues", logo: meeshoLogo, width: "150px", height: "34px" },
];

const TrustedBrands = () => {
  const scrollRef = useRef();

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = 300;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  return (
    <div className="where-other-section ">
    <motion.h2 className="hero-heading text-white"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: "easeOut",delay:0.1 }}
    viewport={{ once: false }}  >Where Others Stop,<br/>Gapalyze Connects Everything</motion.h2>
    <p className="text-white hero-sub-text mt-md-5 mb-md-5">From insight to execution, Gapalyze bridges the gaps others overlook giving you complete control over your growth.</p>
    <div className="where-other-inner row">
      <div className="left-div col-12 col-md-12 col-lg-6 align-items-center">
        <h5 className="mt-5 mb-3 where-box-text">Data chaos, unclear direction.</h5>
        <div className="d-flex justify-content-center">
          <div className="inner-btn me-3">Messy Spreadsheets</div>
          <div className="inner-btn me-3">Guesswork</div>
          <div className="inner-btn">Unclear Sales Sources</div>
        </div>
        <div className="orbit" style={{width:"100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
          {/* <OrbitIcons icons={rotateIcon} radius={150} /> */}
          <OrbitDesign/>
        </div>
        {/* <img src={dataImg} alt="dataImg" className="img-fluid"></img> */}
      </div>
      <div className="right-div col-12 col-md-12 col-lg-6">
        <h5 className="mb-3 where-box-text-active">Clarity that drives revenue.</h5>
        <div className="d-flex justify-content-center">
          <div className="inner-btn me-3">Clean charts</div>
          <div className="inner-btn me-3">Simplified Insights</div>
          <div className="inner-btn">Guided Actions</div>
        </div>
        {/* <img src={dataFillImg} alt="dataFillImg" className="img-fluid mt-5"></img> */}
        <div className="orbit" style={{width:"100%",  display: "flex", justifyContent: "center", alignItems: "center" }}>
          {/* <OrbitIcons icons={icons} radius={150} /> */}
          <OrbitRightDesign/>
        </div>
      </div>

    </div>
    </div>
  );
};

export default TrustedBrands;
